import { RuleProps } from "types/application";

export const LICENCE_TYPE = 'licence-type';
export const TVRO_SYSTEM_DETAILS = 'tvro-system-details';
export const QUANTITY_OF_TV_OUTPUT_POINTS = 'quantity-of-tv-output-points';
export const DETAILS_OF_TV_OUTPUT_POINTS = 'details-of-tv-output-points';
export const DETAILS_OF_SATELLITE_AND_TV_CHANNELS_PROGRAMMES = 'details-of-satellite-and-tv-channels-programmes';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const TVRO_LICENCE = [
    {
        sectionID: LICENCE_TYPE,
        sectionName: 'Licence Type',
        fieldList: [
            {
                id: 'licence-duration',
                label: 'Licence Duration',
                type: 'text',
                span: 12
            },
            {
                id: 'start-date',
                label: 'Start Date',
                type: 'text'
            },
            {
                id: 'expiry-date',
                label: 'Expiry Date',
                type: 'text'
            },
            {
                id: 'sharing-dish',
                label: 'Sharing Dish',
                type: 'text'
            },
            {
                id: 'sharing-licence-no',
                label: 'Sharing Licence No.',
                type: 'text',
                rule: {
                    baseIds: [`${LICENCE_TYPE}-sharing-licence-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${LICENCE_TYPE}-sharing-dish`] === 'No'
                        );
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: TVRO_SYSTEM_DETAILS,
        sectionName: 'TVRO System Details',
        fieldList: [
            {
                id: 'purpose-of-downlink',
                label: 'Purpose of Downlink',
                type: 'text'
            },
            {
                id: 'location-of-tvro-dish',
                label: 'Location of TVRO Dish',
                type: 'text'
            },
            {
                id: 'tvro-system-is-on',
                label: 'TVRO System is on',
                type: 'text'
            },
            {
                id: 'height-of-the-antenna-dish-in-meters',
                label: 'Height of the antenna/dish in meters',
                type: 'text'
            },
            {
                id: 'height-of-the-building-in-metres-above-mean-sea-level',
                label: 'Height of the building in metres above mean sea level (AMSL)',
                type: 'text'
            },
            {
                id: 'height-of-the-building-with-the-antenna-dish-in-metres',
                label: 'Height of the building with the antenna/dish in metres (AMSL)',
                type: 'text'
            },
            {
                id: 'is-the-antenna-dish-located-at-the-highest-point-of-the-building',
                label: 'Is the antenna/dish located at the highest point of the building',
                type: 'text'
            },
            {
                id: 'use-of-downlink-signals',
                label: 'Use of Downlink Signals',
                type: 'text'
            },
            {
                id: 'no-of-dishes',
                label: 'No. of Dishes',
                type: 'text'
            }
        ]
    },
    {
        sectionID: QUANTITY_OF_TV_OUTPUT_POINTS,
        sectionName: 'Quantity of TV Output Point(s)',
        fieldList: [
            {
                id: 'total-number-of-rooms',
                label: 'Total number of rooms',
                type: 'text',
                span: 12
            },
            {
                id: 'total-number-of-tv-output-points',
                label: 'Total number of TV output Points',
                type: 'text'
            }
        ]
    },
    {
        sectionID: DETAILS_OF_TV_OUTPUT_POINTS,
        sectionName: 'Details of TV Output Point(s)',
        fieldList: [
            {
                id: 'details-of-tv-output-points',
                label: '',
                type: 'table2',
                subFields: [
                    {
                        id: 'no',
                        header: 'No.',
                        type: 'text'
                    },
                    {
                        id: 'location-room-description-room-number',
                        header: 'Location/Room Description/Room Number',
                        type: 'text'
                    },
                    {
                        id: 'quantity-of-tv-output-points',
                        header: 'Quantity of TV Output Points',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ]
    },
    {
        sectionID: DETAILS_OF_SATELLITE_AND_TV_CHANNELS_PROGRAMMES,
        sectionName: 'Details of Satellite(s) and TV Channel(s)/Programme(s)',
        fieldList: [
            {
                id: 'details-of-satellite-and-tv-channels-programmes-list',
                label: '',
                type: 'tableAccordion',
                span: 12,
                subFields: [
                    {
                        id: 'details-of-satellite-and-tv-channels-programmes-table',
                        label: '',
                        type: 'table',
                        subFields: [
                            {
                                id: 'no',
                                header: 'No.',
                                type: 'text'
                            },
                            {
                                id: 'satellite-name',
                                header: 'Satellite Name',
                                type: 'text'
                            },
                            {
                                id: 'orbital-longitude',
                                header: 'Orbital Longitude',
                                type: 'text'
                            },
                            {
                                id: 'channel-id-number',
                                header: 'Channel ID/Number',
                                type: 'text'
                            },
                            {
                                id: 'channel-programme-name',
                                header: 'Channel/Programme Name',
                                type: 'text'
                            }
                        ]
                    },
                    {
                        id: 'details-of-satellite-and-tv-channels-programmes-accordion',
                        label: '',
                        type: 'accordion',
                        subFields: [
                            {
                                id: 'channel-programme-description',
                                label: 'Channel/Programme Description',
                                type: 'text'
                            },
                            {
                                id: 'downlink-frequency-mhz',
                                label: 'Downlink Frequency (MHz)',
                                type: 'text'
                            },
                            {
                                id: 'carrier-downlink-bandwidth-mhz',
                                label: '(Carrier) Downlink Bandwidth (MHz)',
                                type: 'text'
                            },
                            {
                                id: 'channel-downlink-bandwidth-mhz',
                                label: '(Channel) Downlink Bandwidth (MHz)',
                                type: 'text'
                            },
                            {
                                id: 'application-type',
                                label: 'Application Type',
                                type: 'text'
                            },
                            {
                                id: 'sample-clips-url',
                                label: 'Sample Clips/URL',
                                type: 'text'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
